import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./ImageTestimonial.css";
import Slider from "react-slick";

import courseImg01 from "../../assests/images/Снимок экрана (1046).png";
import courseImg04 from "../../assests/images/Снимок экрана (1043).png";
import courseImg02 from "../../assests/images/Снимок экрана (1044).png";
import courseImg03 from "../../assests/images/Снимок экрана (1045).png";


const ImageTestimonial = () => {
    const settings = {
        infinite: true,
        dots: true,
        speed: 500,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
    };

    return (
        <section>
            <Container className="image-testimonial-container">
                <Row>
                    <Col lg="10" md="12" className="m-auto">
                        <div className="testimonial__wrapper d-flex justify-content-between align-items-center ">
                            <div className="testimonial__content w-100">
                                <h2 className="mb-4">Python + Физика шешілген жаттығулар</h2>

                                <Slider {...settings}>
                                    <div>
                                        <div className="single__testimonial-content">
                                            <img src={courseImg01} />
                                        </div>
                                    </div>

                                    <div>
                                        <div className="single__testimonial-content">
                                            <img src={courseImg02} />
                                        </div>
                                    </div>

                                    <div>
                                        <div className="single__testimonial-content">
                                            <img src={courseImg03} />
                                        </div>
                                    </div>

                                    <div>
                                        <div className="single__testimonial-content">
                                            <img src={courseImg04} />
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ImageTestimonial;
